import { isArray } from "lodash";

export function doReduce(records, rules) {
  let total = null;
  if (rules.action === "add") {
    records.forEach((record) => {
      if (!isArray(rules.field) && !Number.isNaN(record[rules.field])) {
        total += Number(record[rules.field]);
      } else {
        rules.field.forEach((key) => {
          if (record[key] && record[key] !== "" && !Number.isNaN(record[key])) {
            total += Number(record[key]);
          }
        });
      }
    });
  }
  return total;
}

export function checkEquality(computed, validateConf) {
  let isValid = false;
  if (computed) {
    if (validateConf.equalTo) {
      isValid = computed === validateConf.equalTo;
    }
    if (validateConf.ltEqualTo) {
      isValid = computed <= validateConf.ltEqualTo;
    }
    if (validateConf.gtEqualTo) {
      isValid = computed >= validateConf.ltEqualTo;
    }
    if (validateConf.gt) {
      isValid = computed > validateConf.gt;
    }
    if (validateConf.lt) {
      isValid = computed < validateConf.lt;
    }
  }
  return isValid;
}

export const performComparison = (value1, value2, operator) => {
  switch (operator) {
    case "<":
      return value1 < value2;
    case ">":
      return value1 > value2;
    case "<=":
      return value1 <= value2;
    case ">=":
      return value1 >= value2;
    case "!":
      return value1 !== value2;
    case "=":
      return value1 === value2;
    default:
      return false;
  }
};
